<template>
  <b-card>
    <DeleteModal modalId="modal-delete" @deleteToggle="deleteItem" />
    <b-modal
      :no-close-on-backdrop="true"
      :id="`modal-edit-${index}`"
      ok-only
      centered
      size="lg"
      :title="
        createMode
          ? `${$t('common.add')} ${$t('emergency.temperature')}`
          : `${$t('common.edit')} ${$t('emergency.temperature')}`
      "
      @ok="submitItem()"
    >
      <b-card-text>
        <b-row>
          <b-col md="">
            <b-form-group :label="$t('common.value')" label-for="value">
              <b-form-input
                v-model="EditForm.value"
                type="number"
                :placeholder="$t('common.value')"
              />
            </b-form-group>
          </b-col>
          <b-col md="">
            <b-form-group :label="$t('common.date')" label-for="date">
              <datetime
                input-class="form-control"
                type="datetime"
                v-model="EditForm.date"
                format="Y-m-d H:i:s"
              >
              </datetime>
            </b-form-group>
          </b-col>
        </b-row>
      </b-card-text>
    </b-modal>
    <b-modal
      :no-close-on-backdrop="true"
      :id="`modal-edit-blood-pressure-${index}`"
      ok-only
      centered
      size="lg"
      :title="
        createMode
          ? `${$t('common.add')} ${$t('emergency.bp')}`
          : `${$t('common.edit')} ${$t('emergency.bp')}`
      "
      @ok="submitBpItem()"
    >
      <b-card-text>
        <b-row>
          <b-col md="">
            <b-form-group :label="$t('common.value')" label-for="value">
              <b-form-input
                v-model="EditFormBloodPressure.value"
                :placeholder="$t('common.value')"
              />
            </b-form-group>
          </b-col>
          <b-col md="">
            <b-form-group :label="$t('common.date')" label-for="date">
              <datetime
                input-class="form-control"
                type="datetime"
                v-model="EditFormBloodPressure.date"
                format="Y-m-d H:i:s"
              >
              </datetime>
            </b-form-group>
          </b-col>
        </b-row>
      </b-card-text>
    </b-modal>
    <b-modal
      :id="`modal-edit-pulse-${index}`"
      :no-close-on-backdrop="true"
      ok-only
      centered
      size="lg"
      :title="
        createMode
          ? `${$t('emergency.add emergency')} ${$t('emergency.pulse')}`
          : `${$t('emergency.edit emergency')} ${$t('emergency.pulse')}`
      "
      @ok="submitPulse()"
    >
      <b-card-text>
        <b-row>
          <b-col md="">
            <b-form-group :label="$t('common.value')" label-for="value">
              <b-form-input
                v-model="EditPulseForm.value"
                type="number"
                :placeholder="$t('common.value')"
              />
            </b-form-group>
          </b-col>
          <b-col md="">
            <b-form-group :label="$t('common.date')" label-for="date">
              <datetime
                input-class="form-control"
                type="datetime"
                v-model="EditPulseForm.date"
                format="Y-m-d H:i:s"
              >
              </datetime>
            </b-form-group>
          </b-col>
        </b-row>
      </b-card-text>
    </b-modal>
    <div class="d-flex justify-content-between my-2">
      <!-- <b-button variant="primary" class="mx-2" v-print="emergencyCart">
        {{ $t('surgery.Print-Doctor-Expenses') }}
      </b-button> -->
      <h2>{{ emegencyItem.created_at }}</h2>
      <b-button
        :disabled="!temperatureData"
        @click="printExaminationForm()"
        variant="warning"
        >{{ $t("common.Print Card") }}</b-button
      >
    </div>
    <hr class="invoice-spacing" />

    <b-card>
      <div>
        <h2 class="text-center">
          <b-badge class="p-1" pill variant="info">
            {{ $t("emergency.Patient Personal Info") }}</b-badge
          >
        </h2>
        <h5 class="my-2">
          <b>{{ $t("common.patient-name") }}:</b>
          <p class="mx-2 d-inline d-inline">
            {{ emegencyItem.patient_card.patient.name }}
          </p>
        </h5>
        <h5 class="my-2">
          <b>{{ $t("common.Sex") }}:</b>
          <p class="mx-2 d-inline d-inline">
            {{ emegencyItem.patient_card.patient.gender }}
          </p>
        </h5>
        <h5 class="my-2">
          <b>{{ $t("common.Address") }}:</b>
          <p class="mx-2 d-inline">
            {{ emegencyItem.patient_card.patient.city_name }}
          </p>
        </h5>
        <h5 class="my-2">
          <b>{{ $t("common.Birtdate") }}:</b>
          <p class="mx-2 d-inline">
            {{ emegencyItem.patient_card.patient.birth_date }}
          </p>
        </h5>
        <h5 class="my-2">
          <b>{{ $t("common.Occupation") }}:</b>
          <p class="mx-2 d-inline">
            <!-- {{ emegencyItem.patient_card.patient.cccupation }} -->
          </p>
        </h5>
        <h5 class="my-2">
          <b> {{ $t("emergency.Companinon name") }}:</b>
          <p class="mx-2 d-inline">
            {{ emegencyItem.patient_card.full_companion_name }}
          </p>
        </h5>
      </div>
      <hr class="invoice-spacing" />

      <div class="mt-2">
        <h2 class="text-center">
          <b-badge class="p-1" pill variant="warning">
            {{ $t("emergency.Patient Medical Info") }}</b-badge
          >
        </h2>
        <h5 class="my-2">
          <b> {{ $t("emergency.Patient History") }}:</b>
          <p class="mx-2 d-inline d-inline">
            {{ emegencyItem.patient_card.patient_case }}
          </p>
        </h5>
        <h5 class="my-2">
          <b>{{ $t("emergency.Diagnosis") }}:</b>
          <p class="mx-2 d-inline d-inline">
            {{ emegencyItem.diagnosis }}
          </p>
        </h5>
        <h5 class="my-2">
          <b>{{ $t("emergency.Investigation") }}:</b>
          <p class="mx-2 d-inline">
            {{ emegencyItem.investigation }}
          </p>
        </h5>
        <h5 class="my-2">
          <b>{{ $t("emergency.Examination") }}:</b>
          <p class="mx-2 d-inline">
            {{ emegencyItem.examination }}
          </p>
        </h5>
        <h5 class="my-2">
          <b>{{ $t("emergency.Treatment") }}:</b>
          <p class="mx-2 d-inline">
            {{ emegencyItem.treatment }}
          </p>
        </h5>
        <h2
          class="mt-4 text-center"
          v-if="$store.state.app.permissions.includes('get-emergency-pulse')"
        >
          Patient Pulse
        </h2>
        <div
          class="d-flex justify-content-between"
          v-if="$store.state.app.permissions.includes('get-emergency-pulse')"
        >
          <div class="col-3">
            <h3 class="col-8 mt-4 text-center" v-if="pulseData">
              {{ date }}
            </h3>
          </div>

          <div class="col-2 w-full align-self-end">
            <b-button
              @click="showPulseModal(EditPulseForm, 'create')"
              variant="outline-primary"
              >Add Pulse</b-button
            >
          </div>
        </div>
        <vue-apex-charts
          v-if="
            pulseData &&
            $store.state.app.permissions.includes('get-emergency-pulse')
          "
          type="line"
          height="20%"
          width="100%"
          :options="pulseOptions"
          :series="pulseSeries"
          :markers="true"
        />
        <template v-if="loading">
          <div>
            <div class="d-flex justify-content-center mb-1">
              <b-spinner label="Loading..." />
            </div>
          </div>
        </template>
        <b-table
          :items="pulseData"
          responsive
          :fields="tableColumns"
          primary-key="id"
          show-empty
          empty-text="No matching results found"
          class="position-relative mt-2"
          v-if="!loading"
        >
          <!-- Column: Actions -->
          <template #cell(actions)="data">
            <div class="text-nowrap">
              <!-- @click="printId(data.item.id)" -->
              <ActionsButtons
                deletePerm="delete-emergency-pulse"
                editPerm="update-emergency-pulse"
                @editToggle="showPulseModal(data.item)"
                @deleteToggle="deleteModel(data.item)"
              />
              <!-- Dropdown -->
            </div>
          </template>
        </b-table>
        <template v-if="loading">
          <div>
            <div class="d-flex justify-content-center mb-1">
              <b-spinner label="Loading..." />
            </div>
          </div>
        </template>
        <h2
          class="mt-4 text-center"
          v-if="
            $store.state.app.permissions.includes(
              'get-emergency-blood-pressure'
            )
          "
        >
          Patient Blood Pressure
        </h2>
        <div
          v-if="
            $store.state.app.permissions.includes(
              'get-emergency-blood-pressure'
            )
          "
          class="d-flex justify-content-between"
        >
          <div class="col-3">
            <h3 class="col-8 mt-4 text-center" v-if="bpData">
              {{ date }}
            </h3>
          </div>

          <div class="col-2 w-full align-self-end">
            <b-button
              @click="showBpModal(EditFormBloodPressure, 'create')"
              variant="outline-primary"
              >Add Blood Pressure</b-button
            >
          </div>
        </div>
        <vue-apex-charts
          v-if="
            bpData &&
            $store.state.app.permissions.includes(
              'get-emergency-blood-pressure'
            )
          "
          type="line"
          height="20%"
          width="100%"
          :options="bpOptions"
          :series="bpSeries"
          :markers="true"
        />
        <template v-if="loading">
          <div>
            <div class="d-flex justify-content-center mb-1">
              <b-spinner label="Loading..." />
            </div>
          </div>
        </template>
        <b-table
          v-if="
            bpData &&
            !loading &&
            $store.state.app.permissions.includes(
              'get-emergency-blood-pressure'
            )
          "
          :items="bpData"
          responsive
          :fields="tableColumns"
          primary-key="id"
          show-empty
          empty-text="No matching results found"
          class="position-relative mt-2"
        >
          <!-- Column: Actions -->
          <template #cell(actions)="data">
            <div class="text-nowrap">
              <!-- @click="printId(data.item.id)" -->
              <ActionsButtons
                deletePerm="delete-group"
                editPerm="update-group"
                @editToggle="showBpModal(data.item)"
                @deleteToggle="deleteModel(data.item)"
              />
              <!-- Dropdown -->
            </div>
          </template>
        </b-table>
        <template v-if="loading">
          <div>
            <div class="d-flex justify-content-center mb-1">
              <b-spinner label="Loading..." />
            </div>
          </div>
        </template>
        <h2
          class="mt-4 text-center"
          v-if="
            $store.state.app.permissions.includes('get-emergency-temperature')
          "
        >
          Patient Temperature
        </h2>
        <div
          class="d-flex justify-content-between"
          v-if="
            $store.state.app.permissions.includes('get-emergency-temperature')
          "
        >
          <div class="col-3">
            <h3 class="col-8 mt-4 text-center" v-if="temperatureData">
              {{ date }}
            </h3>
          </div>
          <!-- <div class="col-2 w-full align-self-end">
            <b-button-group>
              <b-button @click="showChart = true" variant="outline-primary"
                >Chart</b-button
              >
              <b-button @click="showTable = true" variant="outline-primary"
                >Table</b-button
              >
            </b-button-group>
          </div> -->
          <div class="col-2 w-full align-self-end">
            <b-button
              @click="show(EditForm, 'create')"
              variant="outline-primary"
              >Add Temp</b-button
            >
          </div>
        </div>
        <vue-apex-charts
          v-if="
            temperatureData &&
            $store.state.app.permissions.includes('get-emergency-temperature')
          "
          type="line"
          height="10%"
          width="100%"
          :options="options"
          :series="series"
          :markers="true"
        />
        <template v-if="loading">
          <div>
            <div class="d-flex justify-content-center mb-1">
              <b-spinner label="Loading..." />
            </div>
          </div>
        </template>
        <b-table
          v-if="
            !loading &&
            $store.state.app.permissions.includes('get-emergency-temperature')
          "
          :items="temperatureData"
          responsive
          :fields="tableColumns"
          primary-key="id"
          show-empty
          empty-text="No matching results found"
          class="position-relative mt-2"
        >
          <!-- Column: Actions -->
          <template #cell(actions)="data">
            <div class="text-nowrap">
              <!-- @click="printId(data.item.id)" -->
              <ActionsButtons
                deletePerm="delete-group"
                editPerm="update-group"
                @editToggle="show(data.item)"
                @deleteToggle="deleteModel(data.item)"
              />
              <!-- Dropdown -->
            </div>
          </template>
        </b-table>
        <template v-if="loading">
          <div>
            <div class="d-flex justify-content-center mb-1">
              <b-spinner label="Loading..." />
            </div>
          </div>
        </template>
      </div>
    </b-card>
    <vue-html2pdf
      :show-layout="false"
      :float-layout="true"
      :enable-download="false"
      :preview-modal="true"
      :paginate-elements-by-height="1400"
      filename="patient card"
      :pdf-quality="2"
      :manual-pagination="false"
      pdf-format="a4"
      pdf-orientation="portrait"
      pdf-content-width="800px"
      @hasStartedGeneration="hasStartedGeneration()"
      @hasGenerated="hasGenerated($event)"
      ref="html2PdfExaminationTable"
    >
      <section dir="ltr" class="pdf-content font-modify m-5" slot="pdf-content">
        <section class="">
          <div
            class="border border-dark p-1"
            style="display: flex; justify-content: space-between"
          >
            <span>
              <pre style="background-color: white">
  Name: {{ emegencyItem.patient_card.patient.name }}
  Sex: {{ emegencyItem.patient_card.patient.gender }}
</pre
              >
            </span>
            <span>
              <p></p>
              <p dir="rtl">
                عنوان المريض : {{ emegencyItem.patient_card.patient.city_name }}
              </p>
            </span>
          </div>
          <div
            class="border border-dark p-1"
            style="display: flex; justify-content: space-between"
          >
            <span>
              <pre style="background-color: white">
  Age:{{ emegencyItem.patient_card.patient.birth_date }}
</pre
              >
            </span>
            <span>
              <p></p>
              <p dir="rtl">مهنة المريض :</p>
            </span>
          </div>
          <div
            class="border border-dark p-1"
            style="display: flex; justify-content: end"
          >
            <span>
              <p></p>
              <p dir="rtl">
                اقرب شخص له: {{ emegencyItem.patient_card.full_companion_name }}
              </p>
            </span>
          </div>
          <table
            class="mb-3 border border-bottom-2"
            style="width: 100%; table-layout: fixed"
          >
            <tr style="height: 115px; border: none">
              <th rowspan="2" style="vertical-align: top">
                <p class="mx-2">
                  History:
                  <span>{{ emegencyItem.patient_card.patient_case }}</span>
                </p>
              </th>
              <th style="vertical-align: top">
                <p class="mx-2">
                  Diagnosis:
                  <span>{{ emegencyItem.diagnosis }}</span>
                </p>
              </th>
              <th style="vertical-align: top">
                <p class="mx-2">
                  Investigation: {{ emegencyItem.investigation }}
                </p>
              </th>
            </tr>
            <tr style="height: 115px; border: none">
              <th rowspan="2" style="vertical-align: top">
                <p class="mx-2">Examination: {{ emegencyItem.examination }}</p>
              </th>
              <th style="vertical-align: top">
                <p class="mx-2">Drug Allergy:</p>
              </th>
            </tr>
            <tr style="height: 115px; border: none">
              <th rowspan="2" style="vertical-align: top">
                <p class="mx-2">Systematic Illness:</p>
              </th>
              <th style="vertical-align: top">
                <p class="mx-2">Treatment: {{ emegencyItem.treatment }}</p>
              </th>
            </tr>
          </table>
        </section>
        <div class="page-break-before"></div>
        <h3 class="mt-4 text-center">Patient temperature on {{ date }}</h3>
        <vue-apex-charts
          class="chart"
          type="line"
          height="27%"
          width="100%"
          :options="options"
          :series="series"
          :markers="true"
        />

        <div class="page-break-before"></div>
        <h3 class="mt-4 text-center">Patient Pulse on {{ date }}</h3>
        <vue-apex-charts
          class="chart"
          type="line"
          height="27%"
          width="100%"
          :options="pulseOptions"
          :series="pulseSeries"
          :markers="true"
        />

        <div class="page-break-before"></div>
        <h3 class="mt-4 text-center">
          Patient Blood Pressure on {{ date }}
        </h3>
        <vue-apex-charts
          class="chart"
          type="line"
          height="27%"
          width="100%"
          :options="bpOptions"
          :series="bpSeries"
          :markers="true"
        />
      </section>
    </vue-html2pdf>
    <!-- <Emergency :data="emegencyItem" /> -->
  </b-card>
</template>
<script>
import {
  BCard,
  BBadge,
  BCardText,
  BRow,
  BCol,
  BButton,
  BButtonGroup,
  BModal,
  BFormGroup,
  BFormInput,
  BSpinner,
  BTable,
} from "bootstrap-vue";
import VueHtml2pdf from "vue-html2pdf";
import VueApexCharts from "vue-apexcharts";
import { Datetime } from "vue-datetime";
// You need a specific loader for CSS files
import "vue-datetime/dist/vue-datetime.css";
import ActionsButtons from "@/components/common/ActionsButtons.vue";
import DeleteModal from "@/components/modals/DeleteModal.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default {
  components: {
    BCard,
    BModal,
    BFormGroup,
    BFormInput,
    BBadge,
    BCardText,
    BTable,
    BRow,
    BCol,
    BButton,
    VueHtml2pdf,
    BButtonGroup,
    ToastificationContent,
    VueApexCharts,
    Datetime,
    BSpinner,
    ActionsButtons,
    DeleteModal,
  },

  props: ["emegencyItem", "index"],

  data() {
    return {
      temperatureData: [],
      loading: false,
      createMode: false,
      tableColumns: [
        { key: "value", sortable: true },
        { key: "date", sortable: true },
        { key: "Actions" },
      ],
      EditPulseForm: {},
      EditFormBloodPressure: {
        name: "",
        date: "",
        value: "",
        _method: "PUT",
      },
      EditForm: {
        name: "",
        date: "",
        _method: "PUT",
      },
      params: {
        form: {},
        path: "",
      },
      date: "",
      options: {},
      pulseOptions: {},
      pulseData: [],
      pulseSeries: [],
      bpSeries: [],
      bpData: [],
      bpOptions: {},
      series: [],
      emergencyCart: {
        id: "emergencyPrint",
      },
    };
  },

  mounted() {
    this.getPatientTemperatureData();
    this.getPatientPulseData();
    this.getPatientBpData();
  },
  methods: {
    formatDate(dateString) {
      const date = new Date(dateString);

      if (date) {
      }
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");

      return `${year}-${month}-${day} ${hours}:${minutes}:00`;
    },

    deleteModel(item) {
      this.deleteForm = item;
      this.$bvModal.show("modal-delete");
    },

    showPulseModal(item, mode) {
      if (mode === "create") {
        this.createMode = true;
        this.EditPulseForm = {
          value: "",
          date: "",
          _method: "POST",
        };
      } else {
        this.createMode = false;
        this.EditPulseForm.id = item.id;
        this.EditPulseForm.value = item.value;
        this.EditPulseForm.date = item.date;
        this.EditPulseForm._method = "PUT";
      }
      this.$bvModal.show(`modal-edit-pulse-${this.index}`);
    },

    showBpModal(item, mode) {
      if (mode === "create") {
        this.createMode = true;
        this.EditFormBloodPressure = {
          value: "",
          date: "",
          _method: "POST",
        };
      } else {
        this.createMode = false;

        this.EditFormBloodPressure.id = item.id;
        this.EditFormBloodPressure.value = item.value;
        this.EditFormBloodPressure.date = item.date;
        this.EditFormBloodPressure._method = "PUT";
      }
      this.$bvModal.show(`modal-edit-blood-pressure-${this.index}`);
    },
    show(item, mode) {
      if (mode === "create") {
        this.createMode = true;
        this.EditForm = {
          value: "",
          date: "",
          _method: "POST",
        };
      } else {
        this.createMode = false;

        this.EditForm.id = item.id;
        this.EditForm.value = item.value;
        this.EditForm.date = item.date;
        this.EditForm._method = "PUT";
      }
      this.$bvModal.show(`modal-edit-${this.index}`);
    },
    async getPatientTemperatureData() {
      this.loading = true;
      await this.getPatient(
        `vital-signs?filter[patient_card_id]=${this.$route.params.id}&include=createdBy&filter[vital_sign_type]=temperature`
      );
      this.loading = false;
      for (let item in this.all_data) {
        if (this.all_data[item] == null) this.all_data[item] = "";
      }
      this.temperatureData = this.all_data.data;
      const categories = this.temperatureData.map((item) => {
        this.responsibleUser = item.created_by.name;
        this.date = item.date.split(" ")[0];

        return item.date.split(" ");
      }); // Extracting dates
      const dataValues = this.temperatureData.map((item) =>
        parseFloat(item.value)
      ); // Extracting values

      // Constructing the options object
      this.options = {
        chart: {
          id: "vuechart-example",
          toolbar: {
            show: false,
          },
          zoom: {
            enabled: false,
          },
        },
        markers: {
          size: [7, 7],
        },
        xaxis: {
          categories: categories,
        },
      };

      // Constructing the series object
      this.series = [
        {
          name: `added by ${this.responsibleUser}`,
          data: dataValues,
        },
      ];
    },
    async getPatientPulseData() {
      this.loading = true;
      await this.getPatient(
        `vital-signs?filter[patient_card_id]=${this.$route.params.id}&include=createdBy&filter[vital_sign_type]=pulse`
      );
      this.loading = false;
      for (let item in this.all_data) {
        if (this.all_data[item] == null) this.all_data[item] = "";
      }
      this.pulseData = this.all_data.data;
      const categories = this.pulseData.map((item) => {
        this.responsibleUser = item.created_by.name;

        this.date = item.date.split(" ")[0];

        return item.date.split(" ");
      }); // Extracting dates
      const dataValues = this.pulseData.map((item) => parseFloat(item.value)); // Extracting values

      // Constructing the options object
      this.pulseOptions = {
        chart: {
          id: "vuechart-example",
          toolbar: {
            show: false,
          },
          zoom: {
            enabled: false,
          },
        },
        markers: {
          size: [7, 7],
        },
        xaxis: {
          categories: categories,
        },
      };

      // Constructing the series object
      this.pulseSeries = [
        {
          name: `added by ${this.responsibleUser}`,
          data: dataValues,
        },
      ];
    },
    async getPatientBpData() {
      this.loading = true;
      await this.getPatient(
        `vital-signs?filter[patient_card_id]=${this.$route.params.id}&include=createdBy&filter[vital_sign_type]=blood_pressure`
      );
      this.loading = false;
      for (let item in this.all_data) {
        if (this.all_data[item] == null) this.all_data[item] = "";
      }
      this.bpData = this.all_data.data;
      const categories = this.bpData.map((item) => {
        this.responsibleUser = item.created_by.name;

        this.date = item.date.split(" ")[0];

        return item.date.split(" ");
      }); // Extracting dates
      const dataValues = this.bpData.map((item) => parseFloat(item.value)); // Extracting values

      // Constructing the options object
      this.bpOptions = {
        chart: {
          id: "vuechart-example",
          toolbar: {
            show: false,
          },
          zoom: {
            enabled: false,
          },
        },
        markers: {
          size: [7, 7],
        },
        xaxis: {
          categories: categories,
        },
      };

      // Constructing the series object
      this.bpSeries = [
        {
          name: `added by ${this.responsibleUser}`,
          data: dataValues,
        },
      ];
    },
    printExaminationForm() {
      this.$refs.html2PdfExaminationTable.generatePdf();
    },
    submitItem(type) {
      this.EditForm.patient_card_id = this.emegencyItem.patient_card.id;
      this.EditForm.date = this.formatDate(this.EditForm.date);
      this.EditForm.vital_sign_type = "temperature";
      if (this.createMode) {
        (this.params.form = this.EditForm),
          (this.params.path = `/vital-signs`),
          this.$store
            .dispatch("create", this.params)
            .then((response) => {
              this.getPatientTemperatureData();
            })
            .catch((error) => {
              if (error.response.status === 400) {
                for (let item in error.response.data) {
                  this.$toast({
                    component: ToastificationContent,
                    position: "top-right",
                    props: {
                      title: "validation error",
                      variant: "danger",
                      text: error.response.data[item][0],
                    },
                  });
                }
              }
            });
      } else {
        (this.params.form = this.EditForm),
          (this.params.path = `/vital-signs/${this.EditForm.id}`),
          this.$store
            .dispatch("update", this.params)
            .then((response) => {
              this.getPatientTemperatureData();
            })
            .catch((error) => {
              if (error.response.status === 400) {
                for (let item in error.response.data) {
                  this.$toast({
                    component: ToastificationContent,
                    position: "top-right",
                    props: {
                      title: "validation error",
                      variant: "danger",
                      text: error.response.data[item][0],
                    },
                  });
                }
              }
            });
      }
    },

    submitPulse() {
      this.EditPulseForm.patient_card_id = this.emegencyItem.patient_card.id;
      this.EditPulseForm.date = this.formatDate(this.EditPulseForm.date);
      this.EditPulseForm.vital_sign_type = "pulse";

      if (this.createMode) {
        (this.params.form = this.EditPulseForm),
          (this.params.path = `/vital-signs`),
          this.$store
            .dispatch("create", this.params)
            .then((response) => {
              this.getPatientPulseData();
            })
            .catch((error) => {
              if (error.response.status === 400) {
                for (let item in error.response.data) {
                  this.$toast({
                    component: ToastificationContent,
                    position: "top-right",
                    props: {
                      title: "validation error",
                      variant: "danger",
                      text: error.response.data[item][0],
                    },
                  });
                }
              }
            });
      } else {
        (this.params.form = this.EditPulseForm),
          (this.params.path = `/vital-signs/${this.EditForm.id}`),
          this.$store
            .dispatch("update", this.params)
            .then((response) => {
              this.getPatientPulseData();
            })
            .catch((error) => {
              if (error.response.status === 400) {
                for (let item in error.response.data) {
                  this.$toast({
                    component: ToastificationContent,
                    position: "top-right",
                    props: {
                      title: "validation error",
                      variant: "danger",
                      text: error.response.data[item][0],
                    },
                  });
                }
              }
            });
      }
    },

    submitBpItem() {
      console.log(this.EditFormBloodPressure);
      this.EditFormBloodPressure.patient_card_id =
        this.emegencyItem.patient_card.id;
      this.EditFormBloodPressure.date = this.formatDate(
        this.EditFormBloodPressure.date
      );
      this.EditFormBloodPressure.vital_sign_type = "blood_pressure";

      if (this.createMode) {
        (this.params.form = this.EditFormBloodPressure),
          (this.params.path = `/vital-signs`),
          this.$store
            .dispatch("create", this.params)
            .then((response) => {
              this.getPatientBpData();
            })
            .catch((error) => {
              if (error.response.status === 400) {
                for (let item in error.response.data) {
                  this.$toast({
                    component: ToastificationContent,
                    position: "top-right",
                    props: {
                      title: "validation error",
                      variant: "danger",
                      text: error.response.data[item][0],
                    },
                  });
                }
              }
            });
      } else {
        (this.params.form = this.EditFormBloodPressure),
          (this.params.path = `/vital-signs/${this.EditFormBloodPressure.id}`),
          this.$store
            .dispatch("update", this.params)
            .then((response) => {
              this.getPatientBpData();
            })
            .catch((error) => {
              if (error.response.status === 400) {
                for (let item in error.response.data) {
                  this.$toast({
                    component: ToastificationContent,
                    position: "top-right",
                    props: {
                      title: "validation error",
                      variant: "danger",
                      text: error.response.data[item][0],
                    },
                  });
                }
              }
            });
      }
    },
    deleteItem() {
      this.$store
        .dispatch("delete", `/vital-signs/${this.deleteForm.id}`)
        .then((response) => {
          this.getPatientTemperatureData();

          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Delete Success",
              icon: "success",
              variant: "info",
              text: "deleted " + this.deleteForm.first_name + " successfully",
            },
          });
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Error",
              variant: "danger",
              text: "Error deleting " + this.deleteForm.first_name,
            },
          });
        });
    },

    deletePulse() {
      this.$store
        .dispatch("delete", `/vital-signs/${this.deleteForm.id}`)
        .then((response) => {
          this.getPatientPulseData();

          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Delete Success",
              icon: "success",
              variant: "info",
              text: "deleted " + this.deleteForm.first_name + " successfully",
            },
          });
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Error",
              variant: "danger",
              text: "Error deleting " + this.deleteForm.first_name,
            },
          });
        });
    },
  },
};
</script>
<style scoped>
.page-break-before {
  page-break-before: always;
}

.chart {
  page-break-inside: avoid;
}

.mb-md-0 {
  margin-top: 8px;
}

table {
  width: 94%;
  border: 1px solid;
  font-size: 11px;
}

.no-border {
  border: 0;
}

.square-dark {
  background-color: rgba(0, 0, 0, 0.2);
}

tr,
th,
td {
  border: 1px solid;
  width: 10px;
  height: 10px;
}

.font-modify {
  letter-spacing: normal !important;
}

.pdf-table {
  page-break-inside: avoid;
}

.square {
  width: 30px;
  /* Smaller width for squares */
  height: 30px;
  /* Smaller height for squares */
  background-color: #000;
  /* Color of the square */
  display: inline-block;
  /* Allows us to set width and height */
}

.centered-text {
  text-align: center;
  border: 2px solid #000;
  /* Border for the cell */
}

#table-above {
  border-collapse: collapse;
  /* Removes space between borders */
  font-size: 12px;
  /* Smaller font size for the entire table */
}

@media print {
  @page {
  }

  .pdf-table {
    page-break-before: avoid;
    page-break-inside: avoid;
  }
}

.pdf-table:first-child {
  margin-top: 1em;
  /* Adjust the value as needed */
  page-break-inside: avoid;
}
</style>
